import { useCallback, useState } from 'react';

/**
 * @returns {[HTMLElement, (event: Event) => void, () => void]}
 */
export default function useButtonAnchor() {
    const [anchor, setAnchor] = useState(null);

    const onClick = useCallback(e => {
        setAnchor(prev => prev ? null : e.target);
    }, []);

    const onClickAway = useCallback(() => setAnchor(null), []);

    return [anchor, onClick, onClickAway];
}